// extracted by mini-css-extract-plugin
export default {"modalCustom":"styles_modalCustom__-k+KL"};